export const iconFontAwesomeHalloweenGhost = (
	<i className="fa-solid fa-ghost"></i>
);
